import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { format } from "date-fns"

interface Payment {
  id: string
  amount: number
  status: string
  payment_date: string | null
  transaction_reference: string | null
}

interface PaymentHistoryProps {
  payments: Payment[]
}

export function PaymentHistory({ payments }: PaymentHistoryProps) {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Date</TableHead>
          <TableHead>Amount</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Reference</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {payments.map((payment) => (
          <TableRow key={payment.id}>
            <TableCell>
              {payment.payment_date
                ? format(new Date(payment.payment_date), "MMM d, yyyy")
                : "Pending"}
            </TableCell>
            <TableCell>${payment.amount.toFixed(2)}</TableCell>
            <TableCell className="capitalize">{payment.status}</TableCell>
            <TableCell>{payment.transaction_reference || "N/A"}</TableCell>
          </TableRow>
        ))}
        {payments.length === 0 && (
          <TableRow>
            <TableCell colSpan={4} className="text-center">
              No payment history found
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  )
}